import { render, staticRenderFns } from "./ProductTypeViewForm.vue?vue&type=template&id=4df1e7fc&scoped=true&"
import script from "./ProductTypeViewForm.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeViewForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeViewForm.vue?vue&type=style&index=0&id=4df1e7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df1e7fc",
  null
  
)

export default component.exports